module.exports = __webpack_public_path__ + "media/images/bg/honeycombs-0dcd8b88abcd6310843a2c4e307c5698.svg";